<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">

    <div style="width: 3.8021rem;display: flex;justify-content: space-between;">
      <div class="title">我的需求</div>
      <button @click="$router.push('/personstudent/send')">新增需求</button>
    </div>
    <div class="line"></div>
    <div class="txttitle">
      <span>科目</span>
      <span style="width: .651rem;">需求发布时间</span>
      <span>操作</span>
    </div>
    <div class="mline"></div>
    <div class="box" v-for="item in list" :key="item.did">
      <div class="subject">{{ item.itemId ? subjectlist[item.itemId] : '预约：' + item.contractTeacher }}</div>
      <div class="time">{{ time(item.time) }}</div>
      <div class="change">
        <div @click="$router.push('/personstudent/send#' + item.did)">编辑</div>
        <div @click="open(item.did)">删除</div>
      </div>
    </div>

  </div>
</template>
<style>
.msgbox {
  width: 480px !important;
}

.boxconfirm {
  width: 90px !important;
  height: 32px !important;
  background: rgb(1, 162, 153) !important;
  border-radius:
    4px !important;

}
</style>
<script>
export default {
  methods: {
    open(a) {
      this.$alert('<span>需求删除之后无法恢复，如果仅需要编辑部分内容，请点击“编辑”。</span>', '提示', {
        dangerouslyUseHTMLString: true,
        customClass: 'msgbox',
        confirmButtonText: '确定删除',
        showCancelButton: true,
        confirmButtonClass: 'boxconfirm'
      }).then(() => {

        this.$http.delete('/Api/Parent/Demand/' + a, {
          headers: {
            Authorization: localStorage.getItem('Authorization')
          }
        }).then(res => {
          console.log(res);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.$router.go(0);
        }).catch(err => {
          console.log(err);
          this.$message({
            type: 'error',
            message: '删除失败!'
          });
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    time(a) {
      const date = new Date(a);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const dateString = `${year}年${month}月${day}日${hour}:${minute}`;
      return dateString;
    }
  }, data() {
    return {
      list: [],
      subjectlist: {
        10: '小学全科',
        11: '小学语文',
        12: '小学奥数',
        13: '小学数学',
        14: '小学英语',
        15: '小学作业辅导',
        20: '初中全科',
        21: '初中语文',
        22: '初中英语',
        23: '初中数学',
        24: '初中物理',
        25: '初中化学',
        30: '高中数学',
        31: '高中语文',
        32: '高中英语',
        33: '高中物理',
        34: '高中化学',
        35: '高中生物',
        36: '高中历史',
        37: '高中政治',
        38: '高中地理',
        40: '法语',
        41: '德语',
        42: '西班牙语',
        43: '日语',
        44: '葡萄牙语',
        45: '韩语',
        50: '音乐',
        51: '美术',
        52: '舞蹈',
        53: '体育',
        54: '体育',
        60: '其他'
      }
    }
  },
  created() {
    this.$http.get('/Api/Parent/Demands', {
      params: {
        pageNumber: 1,
        pageSize: 999,
      },
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }

    }).then(res => {
      let alldata = res.data.data.records;
      this.list = alldata;
      console.log(res.data.data.records);

    })
  },

}
</script>

<style scoped>
.title {
  /* 修改手机号 */
  height: 32px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;

}

.line {
  /* Line */
  width: 750px;
  height: 2px;
  background: rgb(220, 223, 230);
  margin-top: 8px;
}

button {
  width: 90px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 20px;
}

.txttitle {
  width: 625px;
  height: 25px;
  display: flex;
  justify-content: space-between;
  margin-top: 21px;
  margin-left: 23px;
}

.txttitle span {
  display: block;
  width: 40px;
  height: 25px;
  color: rgb(48, 49, 51, .9);
  font-family: 苹方;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.01px;
  text-align: left;
}

.mline {
  /* 直线 11 */
  width: 750px;
  height: 1px;
  background: rgb(220, 223, 230);
  margin-top: 8px;
}

.box {
  width: 682px;
  height: 33px;
  display: flex;
  margin-left: 27px;
  margin-top: 19px;
  position: relative;
  cursor: default;
}

.box::before {
  content: '';
  width: 750px;
  height: 1px;
  background: rgb(235, 238, 245);
  position: absolute;
  left: -27px;
  top: 33px;
}

.subject {
  /* 高中 */
  width: 90px;
  height: 33px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01px;
}


.time {
  /* 2023年1月1日19：00 */
  width: 180px;
  height: 33px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01px;
  text-align: left;
  transform: translateX(155px);

}

.change {
  display: flex;
  width: 107px;
  justify-content: space-between;
  transform: translateX(310px);
}

.change div {
  /* 编辑 */
  width: 51px;
  height: 33px;
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/studentxuqiu.vue